import { useState } from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ErrorBoundary } from 'react-error-boundary';
import { Col, Row } from 'react-bootstrap';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import SubscriberPortalLogo from '../../../../../assets/images/subscriberportal_header.svg';
import NtisLogoIcon from '../../../../../assets/images/ntislogo-icon.svg';
import ToggleIcon from '../../../../../assets/images/dots-toggle-icon.png';
import SideNavSubscriberPortal from '../../../../ntisui/Molecules/SideNavSubscriberPortal';
import SubscriberDataFeed from '../SubscriberDataFeedContainer';
import { litrals } from '../../../../../constants/Litrals';
import { subscriberPortalnavLinks } from '../../../../../constants/Constants';
import AvailableDataFeed from '../AvailableDataFeedContainer';
import HowToConfigure from '../HowToConfigure';
import HowItWorks from '../HowItWorks';
import DataFeedPolicy from '../DataFeedPolicyContainer';
import Welcome from '../Welcome';
import AvailableFeeds from '../AvailableFeeds';
import Feedback from '../Feedback';
// import Help from '../Help';
import ConfigureDataFeed from '../ConfigureDataFeedContainer';
import DownloadFeeds from '../DownloadFeeds';
import ErrorFallback from '../../../../App/ErrorFallback';
import './_SubscriberPortalConatiner.scss';

const SubscriberPortalConatiner = () => {
  const isAuthenticated = useIsAuthenticated();
  const match = useRouteMatch();
  const [sidenavOpen, setSidenavOpen] = useState(true);

  const renderMain = () => {
    return (
      <Switch>
        <Route exact path={`${match.path}`} component={Welcome} />
        <Route
          path={`${match.path}/howtoconfigure`}
          component={HowToConfigure}
        />
        <Route path={`${match.path}/howitworks`} component={HowItWorks} />
        <Route
          path={`${match.path}/availablefeed`}
          component={AvailableFeeds}
        />
        {/* <Route path={`${match.path}/help`} component={Help} /> */}
        <Route
          path={`${match.path}/subscriberdatafeed`}
          component={SubscriberDataFeed}
        />
        <Route path="/subscriberportal/pullfeeds" component={DownloadFeeds} />
        <Route path={`${match.path}/contactus`} component={Feedback} />
        {isAuthenticated && (
          <>
            <Route
              path={'/subscriberportal/availabledatafeed'}
              component={AvailableDataFeed}
            />
            <Route
              path={`${match.path}/datafeedpolicy`}
              component={DataFeedPolicy}
            />
            <Route
              path="/subscriberportal/configuredatafeed/:id"
              component={ConfigureDataFeed}
            />
            <Route
              path="/subscriberportal/editdatafeed/:id"
              component={ConfigureDataFeed}
            />
          </>
        )}
        <Redirect to="/subscriberportal"></Redirect>
      </Switch>
    );
  };

  return (
    <div className="subscriber-portal-container">
      <Row className="subscriber-portal-subheader">
        <Col className="subheader-logo">
          <img src={SubscriberPortalLogo} alt="subscriber logo" />
        </Col>
        <Col>
          <p className="subheader-heading">{litrals.subscriberPortal}</p>
        </Col>
        <Col>
          <img
            className="subheader-ntislogo-icon"
            alt="NTIS"
            src={NtisLogoIcon}
          />
          {!sidenavOpen ? (
            <img
              className="subheader-mobile-toggle-icon"
              alt="mobile-toggle-icon"
              src={ToggleIcon}
              onClick={() => setSidenavOpen(!sidenavOpen)}
            />
          ) : (
            <FontAwesomeIcon
              className="subheader-mobile-toggle-icon"
              icon={faTimes as IconProp}
              title="close-icon"
              onClick={() => setSidenavOpen(!sidenavOpen)}
            />
          )}
        </Col>
      </Row>
      <Row className="no-gutters ">
        <SideNavSubscriberPortal
          open={sidenavOpen}
          navLinkItems={subscriberPortalnavLinks}
          onLinkClick={() => setSidenavOpen(!sidenavOpen)}
        ></SideNavSubscriberPortal>
        <Col>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <div className="subscriber-portal">{renderMain()}</div>
          </ErrorBoundary>
        </Col>
      </Row>
    </div>
  );
};

export default SubscriberPortalConatiner;
